import {
    apiRequest,
    kgbCreateManual,
    employeeList,
    getSalaryEmployee,
} from "../../../../../services/adapters/kepegawaian/kgbService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", kgbCreateManual, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }

    fetchSalary = async (query) => {
        return await apiRequest("get", getSalaryEmployee, {
            params: query
        }, true)
    }

}

export default CreateRepository